var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearchNotFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "49px",
    viewBox: "0 0 50 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSearchNotFound") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M206.51378,267.915981 L195.784236,257.492069 C195.727213,257.43667 195.660325,257.397948 195.600737,257.346382 C197.711959,254.235004 198.944162,250.51059 198.944162,246.505345 C198.944162,235.610058 189.853084,226.777778 178.638748,226.777778 C167.424412,226.777778 158.333333,235.610058 158.333333,246.505153 C158.333333,257.400056 167.424214,266.232528 178.63855,266.232528 C182.761352,266.232528 186.594699,265.035402 189.797245,262.984281 C189.850322,263.041981 189.889981,263.106965 189.947004,263.162364 L200.676745,273.58666 C202.288574,275.152413 204.901754,275.152413 206.51378,273.58666 C208.125412,272.020715 208.125412,269.481926 206.51378,267.915981 Z M178.638748,259.393669 C171.311822,259.393669 165.372383,253.62331 165.372383,246.505153 C165.372383,239.386805 171.312019,233.616445 178.638748,233.616445 C185.965279,233.616445 191.904915,239.386996 191.904915,246.505153 C191.904915,253.62331 185.965279,259.393669 178.638748,259.393669 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter-Search-Username--not-find",
    transform: "translate(-158.000000, -226.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icSearchNotFound",
    fillOpacity: 0.5,
    fill: "#646464",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchNotFound);
export default __webpack_public_path__ + "static/media/icSearchNotFound.33c1f19aab269190ce2096449838845c.svg";
export { ForwardRef as ReactComponent };